/**
 * FE column key → Assessments/Admin `sort_by` (ApplyVqaSorting).
 * "Request Date" column uses FE key `requested_on` but API field is `request_date`
 * (orders by `vqa_created_on`).
 */
export const ADMIN_ASSESSMENTS_API_SORT_FIELD = {
  sponsor_name: "sponsor_name",
  Provider_name: "provider_name",
  requested_on: "request_date",
};

/**
 * First-load sort for Admin Assessments History (`Assessments/Admin`).
 */
export const ADMIN_ASSESSMENTS_DEFAULT_SORT_CONFIG = {
  requested_on: { direction: "desc" },
};

/**
 * @param {Record<string, { direction?: string }>} sortConfig
 * @returns {{ orderBy: string, sortDirection: 'asc' | 'desc' } | undefined}
 */
export function sortConfigToAdminAssessmentsApiParams(sortConfig) {
  const key = Object.keys(sortConfig || {})[0];
  if (!key) return undefined;
  const direction = sortConfig[key]?.direction;
  if (direction !== "asc" && direction !== "desc") return undefined;
  const orderBy = ADMIN_ASSESSMENTS_API_SORT_FIELD[key];
  if (!orderBy) return undefined;
  return { orderBy, sortDirection: direction };
}

/**
 * Date value shown / sorted as Request Date on Admin Assessments History.
 * API returns `vqa_created_on` (legacy FE key was `requested_on`).
 */
export function getAdminAssessmentRequestDate(item) {
  return item?.vqa_created_on ?? item?.requested_on ?? null;
}
